"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wheelAnalysis = exports.view = exports.vehicle = exports.task = exports.part = exports.inspection = exports.image = exports.damage = exports.damageArea = void 0;
var schema_1 = require("./damageAreas/schema");
Object.defineProperty(exports, "damageArea", { enumerable: true, get: function () { return __importDefault(schema_1).default; } });
var schema_2 = require("./damages/schema");
Object.defineProperty(exports, "damage", { enumerable: true, get: function () { return __importDefault(schema_2).default; } });
var schema_3 = require("./images/schema");
Object.defineProperty(exports, "image", { enumerable: true, get: function () { return __importDefault(schema_3).default; } });
var schema_4 = require("./inspections/schema");
Object.defineProperty(exports, "inspection", { enumerable: true, get: function () { return __importDefault(schema_4).default; } });
var schema_5 = require("./parts/schema");
Object.defineProperty(exports, "part", { enumerable: true, get: function () { return __importDefault(schema_5).default; } });
var schema_6 = require("./tasks/schema");
Object.defineProperty(exports, "task", { enumerable: true, get: function () { return __importDefault(schema_6).default; } });
var schema_7 = require("./vehicles/schema");
Object.defineProperty(exports, "vehicle", { enumerable: true, get: function () { return __importDefault(schema_7).default; } });
var schema_8 = require("./views/schema");
Object.defineProperty(exports, "view", { enumerable: true, get: function () { return __importDefault(schema_8).default; } });
var schema_9 = require("./wheelAnalysis/schema");
Object.defineProperty(exports, "wheelAnalysis", { enumerable: true, get: function () { return __importDefault(schema_9).default; } });
//# sourceMappingURL=schemas.js.map